module.exports = __webpack_public_path__ + "static/media/chevron-right-white.9210ea72.svg";